export default __webpack_public_path__ + "static/media/vibe_bg_img_new.d836aa6b.jpg";